// Formate proprement les erreurs API (FastAPI renvoie un tableau d'objets pour les 422 Pydantic)
export const errMsg = (err, fallback = "Une erreur est survenue") => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((e) => e.msg || String(e)).join(", ");
  if (typeof d === "string" && d) return d;
  return fallback;
};
